"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var reactGa = require("react-ga");
var config_1 = require("../config");
window.onerror = function (description) { return reactGa.exception({ description: description }); };
function initialize() {
    reactGa.initialize(config_1.default.google.analytics.trackingId, { titleCase: false });
}
exports.initialize = initialize;
function setUserId(userId) {
    reactGa.set({ userId: userId });
}
exports.setUserId = setUserId;
function logPageView(page) {
    reactGa.pageview(page);
}
exports.logPageView = logPageView;



//////////////////
// WEBPACK FOOTER
// ./src/infra/analytics.ts
// module id = 128
// module chunks = 0